import { PreferencesService } from "app/services/preferences/preferencesService";

import { ONBOARDING_AGENT_HAS_OPENED_PREFERENCE_KEY } from "./onboardingAgentConstants";

let hasOpenedInCurrentRuntime = false;

const hasOpenedPreference = (): boolean => Boolean(PreferencesService.get(ONBOARDING_AGENT_HAS_OPENED_PREFERENCE_KEY));

const isFirstOpen = (): boolean => !hasOpenedInCurrentRuntime && !hasOpenedPreference();

const markOpened = (): Promise<Record<string, boolean>> => {
    hasOpenedInCurrentRuntime = true;

    return PreferencesService.add({
        [ONBOARDING_AGENT_HAS_OPENED_PREFERENCE_KEY]: true,
    });
};

export const onboardingAgentPreferencesService = {
    isFirstOpen,
    markOpened,
};
